import React from 'react'
import { isLdFlagInABTest } from '../../utils/abTestsUtils'
import { SHOW_EMPTY_REVIEWS } from '../../../../../common/constants'
import { useDisplayingBVComponents } from '../../hooks/useDisplayingBVComponents'

const BazaarvoiceRatingSummary = ({ productId, productsTogglesToDataLayer, showEmptyReviews }) => {
  useDisplayingBVComponents(showEmptyReviews)
  const handleBVRatingClick = () => {
    if (isLdFlagInABTest(SHOW_EMPTY_REVIEWS, productsTogglesToDataLayer)) {
      window?.dataLayer?.push({
        event: 'ldFlaggedFeature',
        ldFlag: SHOW_EMPTY_REVIEWS,
        ldFlagStatus: true,
        ldVariation: 'top-rating-clicked'
      })
    }
  }
  return (
    <div className='mxd-rating' onClick={handleBVRatingClick}>
      <div data-bv-show='rating_summary' data-bv-product-id={productId}></div>
    </div>
  )
}

export default React.memo(BazaarvoiceRatingSummary)
